import * as React from "react"

import { StyledTabs, Tab } from "./Styles"

interface TabsProps<ItemType extends { id: number }> {
  selectedItem: ItemType
  items: Array<ItemType>
  onSelect: (item: ItemType) => void
  label: (item: ItemType) => string
}

const Tabs = <ItemType extends { id: number }>({
  selectedItem,
  items,
  onSelect,
  label,
}: TabsProps<ItemType>): JSX.Element => {
  return (
    <StyledTabs>
      {items.map((item) => (
        <Tab key={item.id} isActive={item.id === selectedItem.id} onClick={() => onSelect(item)}>
          {label(item)}
        </Tab>
      ))}
    </StyledTabs>
  )
}

export default Tabs
